export default {
    state() {
        return {
            user: null,
        };
    },

    getters: {
        /**
         * @param {object} state
         * @return object
         */
        user: (state) => state.user,

        /**
         * @param {object} state
         * @return string|null
         */
        userName: (state) => state.user.name,

        /**
         * @param {object} state
         * @return array
         */
        roles: (state) => {
            const roles = state.user.roles;
            return Array.isArray(roles) ? roles : [];
        },

        /**
         * @param {object} state
         * @return boolean
         */
        isAuthenticated: (state) => !!state.user,
    },

    mutations: {
        /**
         * @param {object} state
         * @param {object} user
         */
        setUser(state, user) {
            state.user = user;
        },

        /**
         * @param {object} state
         */
        resetUser(state) {
            state.user = null;
        },
    },
};